import type { TranslationResource } from './en';

export const es: TranslationResource = {
  title: 'AutoCut - Instalador',
  downloading: 'Descargando AutoCut',
  downloadedTitle: '¡AutoCut se ha descargado correctamente !',
  closingCountdown: 'Cerrando en {{count}} segundos',
  alreadyInstalledTitle: 'AutoCut ya está instalado',
  alreadyInstalledHelp:
    'AutoCut ahora funciona como aplicación de escritorio. Puedes desinstalar esta extensión desde la aplicación Creative Cloud.',
};
